import { render, staticRenderFns } from "./CarSaleTable.vue?vue&type=template&id=537c6144&"
import script from "./CarSaleTable.vue?vue&type=script&lang=js&"
export * from "./CarSaleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports